<template>
  <v-card>
    <v-card-title>Gegevens</v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="6">
            <h3>Bedrijfsnaam</h3>
            <p>{{ supplier.bedrijfsnaam }}</p>
          </v-col>
          <v-col cols="6">
            <h3>Telefoonnummer</h3>
            <p>{{ supplier.telefoonnummer }}</p>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <h3>Naam</h3>
            <p>{{ supplier.naam }}</p>
          </v-col>
          <v-col cols="6">
            <h3>Email Adres</h3>
            <p>{{ supplier.email }}</p>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <h3>Straat + huisnummer</h3>
            <p>{{ supplier.straat }} {{ supplier.huisnummer }}</p>
          </v-col>
          <v-col cols="6">
            <h3>Rekeningnummer</h3>
            <p>{{ supplier.rekeningnummer }}</p>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <h3>Postcode</h3>
            <p>{{ supplier.postcode }}</p>
          </v-col>
          <v-col cols="6">
            <h3>KvK-nummer</h3>
            <p>{{ supplier.kvk }}</p>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <h3>Plaats</h3>
            <p>{{ supplier.plaats }}</p>
          </v-col>
          <v-col cols="6">
            <h3>BTW-nummer</h3>
            <p>{{ supplier.btw }}</p>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <h3>Rubrieken</h3>
            <div v-if="supplier.rubrieken">
              <ul
                v-for="rubriek in supplier.rubrieken.split(';;;;')"
                :key="rubriek"
              >
                <li>{{ rubriek }}</li>
              </ul>
            </div>
          </v-col>
          <v-col cols="6">
            <h3>Werkgebied</h3>
            <div v-if="supplier.werkgebied">
              <ul
                v-for="rubriek in supplier.werkgebied.split(';;;;')"
                :key="rubriek"
              >
                <li>{{ rubriek }}</li>
              </ul>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <h3>Kosten per lead</h3>
            <p>€ {{ supplier.prijs }}</p>
          </v-col>
          <v-col cols="6">
            <h3>Opbrengsten per partner</h3>
            <p>€ {{ supplier.affiliatePrijs }}</p>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";

export default Vue.extend({
  name: "SupplierInfo",

  data: () => ({
    valid: false,
  }),

  props: {
    supplier: Object,
  },

  computed: {
    ...mapGetters({
      user: "user",
    }),
  },

  methods: {},
});
</script>

<style>
</style>